module.exports = __webpack_public_path__ + "img/right2.52654c01.png";